import { useState } from "react";
import Modal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";

var MonitorApi = require('monitor-api');

export default function StreckenkatUpdate({ rowEntry, reloadData, instance }) {
    const [showModal, setShowModal] = useState(false);
    const [inputs, setInputs] = useState({});
    const [update, setUpdate] = useState(new MonitorApi.UpdateStreckenkategorie());
    const [upAvailable, setUpAvailable] = useState(false);


    const openModal = event => {
        setInputs({
            kategorie: rowEntry.original.kategorie,
            bemerkung: rowEntry.original.bemerkung
        })
        setUpdate(pre => ({ ...pre, "katId": rowEntry.original.id }))
        setShowModal(true);
        setUpAvailable(false);
    }

    const closeModal = () => {
        setUpdate({});
        setShowModal(false);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const changeEntry = event => {
        setUpAvailable(true);
        setUpdate(old => ({ ...old, [event.target.id]: event.target.value }));
    }

    const saveChanges = event => {
        event.preventDefault();
        let result = new Promise((resolve) =>
            instance.updateStrkatStreckenkategorieStrkatIdPatch(update, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Änderungen gespeichert`);
                    resolve(data);
                }
            }))
        result.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    return (
        <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saveChanges}>
                    <h3>Änderungen eintragen:</h3>
                    <MyModalContentRow>
                        <label>Bezeichnung:
                            <MyModalContentTextInput id="kategorie"
                                onChange={changeEntry}
                                value={update.kategorie ? update.kategorie : inputs.kategorie} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Beschreibung:
                            <MyModalContentTextInput id="bemerkung"
                                onChange={changeEntry}
                                value={update.bemerkung ? update.bemerkung : inputs.bemerkung} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable}>Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbrechen</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </>)
}